<!-- 期货日内账户申请表单 -->
<template>
  <div class="fdmt-apply-form">
    <!-- TODO 内容样式丢失 -->
    <div class="t-and-c-box">
      <div class="t-and-c-text p-20 apply-text" ref="applyTradeAccountScrollbar" :style="{height: popUpViewHight}" v-html="tAndCText"></div>
    </div>
    <fdtmArticleContent
    :isFinishRead="isFinishRead"
    @submitForm="submitForm"
    :status="status"
    ></fdtmArticleContent>
  </div>
</template>
<script>
import fdtmArticleContent from './fdtmArticleContent'
export default {
  props: {
    status: {
      type: String,
      default: ''
    }
  },
  components: {
    fdtmArticleContent
  },
  data () {
    return {
      isFinishRead: false
    }
  },
  computed: {
    tAndCText () {
      return this.$t('applyTradeAccount.applyFDTMTandC')
    },
    popUpViewHight () {
      return document.documentElement.clientHeight * 0.35 + 'px'
    }
  },
  async mounted () {
    window.uploadPic = this.Util.uploadPicBinder(this)
    window.addEventListener('scroll', this.listenScrollbar, true)
  },
  destroyed () {
    //  删除监听事件
    window.removeEventListener('scroll', this.listenScrollbar, true)
  },
  methods: {
    // 监听scrollbar滚动事件
    listenScrollbar () {
      let scrollTop = this.$refs['applyTradeAccountScrollbar'].scrollTop // 滚动条滚动距离
      let scrollTopMax = this.$refs['applyTradeAccountScrollbar'].scrollTopMax // 浏览器总高度
      let scrollheight = this.$refs['applyTradeAccountScrollbar'].scrollHeight
      let clientHeight = this.$refs['applyTradeAccountScrollbar'].clientHeight
      if (parseInt(scrollTop + clientHeight) >= parseInt(scrollheight) || parseInt(scrollTop) >= parseInt(scrollTopMax)) {
        this.isFinishRead = true
      }
    },
    submitForm (val) {
      this.$emit('submitForm', val)
    }
  }

}
</script>
<style lang="scss" scoped>
.fdmt-apply-form{
  .notice-text {
    background: #f3f4f6;
    line-height: 20px;
    padding: 15px;
    font-size: 12px;
    color: #666;
    text-align: left;
    font-family: PingFangSC-Regular;
  }
  .apply-text {
    line-height: 1.8
  }
  .t-and-c-box{
    .t-and-c-text{
      background: #f3f4f6;
      color: #666;
      overflow-y: scroll;
    }
  }
}
</style>
